import type { GameSnapshot } from "../game/runtime/types";
import { formatDuration } from "./format";

export function eventRailStateText(id: string, snapshot: GameSnapshot, fallback: string): string {
  if (id === "auto") {
    if (snapshot.auto.active) {
      return snapshot.auto.pausedByStorm ? "STORM PAUSE" : formatDuration(snapshot.auto.activeRemainingSeconds);
    }
    return `TICKETS ${snapshot.auto.storageCount}/${snapshot.auto.storageCap}`;
  }

  if (id === "overdrive") {
    const overdrive = snapshot.events.overdrive;
    if (overdrive.blockedByStorm && !overdrive.active) {
      return "DISABLED";
    }
    if (overdrive.active) {
      return `${formatDuration(overdrive.activeSeconds)} ${overdrive.laneLabel}`;
    }
    if (snapshot.progress.prestigeLevel > 0 && overdrive.prestigeUsesRemaining > 0) {
      return `P-OD ${overdrive.prestigeUsesRemaining}/2`;
    }
    return overdrive.cooldownSeconds > 0 ? formatDuration(overdrive.cooldownSeconds) : "READY";
  }

  if (id === "storm") {
    const storm = snapshot.events.storm;
    if (storm.active) {
      return storm.stopPending ? "STOP?" : `${storm.scored}/${storm.totalCores}`;
    }
    if (storm.cooldownSeconds > 0) {
      return formatDuration(storm.cooldownSeconds);
    }
    if (storm.blockedByOverdrive) {
      return "DISABLED";
    }
    return storm.ready ? "READY" : fallback;
  }

  return fallback;
}
